import { LayoutTableContainer } from '@/pages/orders/_layouts/LayoutTableContainer';
import { LayoutReviewContainer, LayoutReviewsBody } from '../../_layouts/LayoutsReviews';
import InquiryBody from './InquiryBody';
import GlobalSpinner from '@/components/organisms/GlobalSpinner';

import type { InquiryItem } from '@/types/api';

interface TableSectionProps {
  isLoading?: boolean;
  tableOrderList: InquiryItem[];
}

const TableSection = ({ isLoading, tableOrderList }: TableSectionProps) => {
  if (isLoading) return <GlobalSpinner />;

  return (
    <LayoutTableContainer>
      <LayoutReviewContainer>
        <LayoutReviewsBody>
          <InquiryBody inquries={tableOrderList} />
        </LayoutReviewsBody>
      </LayoutReviewContainer>
    </LayoutTableContainer>
  );
};

export default TableSection;
